export enum SUPPORTED_MAIN_CHAIN_IDS {
  MAINNET = 1,
  OPTIMISM = 10,
  POLYGON = 137,
  ARBITRUM = 42161,
}

export enum SUPPORTED_TEST_CHAIN_IDS {
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,
}

export enum SUPPORTED_MAIN_CHAINS_EIP155 {
  MAINNET = 'eip155:1',
  OPTIMISM = 'eip155:10',
  POLYGON = 'eip155:137',
  ARBITRUM = 'eip155:42161',
}

export enum SUPPORTED_TEST_CHAINS_EIP155 {
  ROPSTEN = 'eip155:3',
  RINKEBY = 'eip155:4',
  GÖRLI = 'eip155:5',
  KOVAN = 'eip155:42',
}

export enum SUPPORTED_MAIN_CHAINS_NAMES {
  MAINNET = 'Mainnet',
  OPTIMISM = 'Optimism',
  POLYGON = 'Polygon',
  ARBITRUM = 'Arbitrum',
}

export enum SUPPORTED_TEST_CHAINS_NAMES {
  ROPSTEN = 'Ropsten',
  RINKEBY = 'Rinkeby',
  GÖRLI = 'Gorli',
  KOVAN = 'Kovan',
}
export const RAINBOW_BUTTON_ID = '1628799713918-rainbow-button';
